
import React, {useContext ,useState} from 'react';
import Cookies from 'js-cookie';
import { Contextone } from './Context';
import ReactPlayer from 'react-player';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Slideshow = ({ data, bannervisible ,istype }) => {
    const [imageLoaded, setImageLoaded] = useState({});
    const uid = Cookies.get('userid');

    const countercontext = useContext(Contextone);
    const logo = countercontext.isLogo;

    const handleImageLoad = (index) => {
        setImageLoaded((prevState) => ({
            ...prevState,
            [index]: true,
        }));
    };
    const addDefaultImg = ev => {
        ev.target.src = logo;
     }

     const decodeVal = (str) => {
        return btoa(str);
      }
     const slugify = (text) => {
        return text.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
      };

      const createEncodedData = (id, type_id, video_type, upcoming_type) => {
        const str = `${id}-${type_id}-${video_type}-${upcoming_type}`; 
        return decodeVal(str); 
      };

    // const settings = {
    //     dots: true,
    //     infinite: false,
    //     speed: 1500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     autoplaySpeed: 5000,
    //     pauseOnHover: false,
    //     ...bannervisible && {
    //         nextArrow: <SampleNextArrow />,
    //         prevArrow: <SamplePrevArrow />
    //     }
    // };
    const settings = {
        dots: true,
        infinite: data.length > 1, 
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        ...bannervisible && {
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />
        }
    };
    

    return (
        <div className="Slideshow">
            <style>
                {`
                .slick-prev:before, .slick-next:before {
                    font-size: 35px; 
                }
            `}
            </style>
            <Slider {...settings}>
                {data.map((type, index) => (
                    <div key={index} data-index={index}>
                        {type.is_live_url ? (
                            uid ? (
                                <Link to={{ pathname: '/live/0/0/0/0', state: { url: type.video_320 } }} className="image-gradient">
                                    <div className='live-wrapper'>
                                        <img src={imageLoaded[index] ? type.banner_image : logo}
                                        onLoad={() => handleImageLoad(index)}
                                        onError={addDefaultImg}
                                        height="600vh" className="d-block w-100 mscreen" alt="..." />
                                    </div>
                                </Link>
                            ) : (
                                <Link to="/login">
                                    <div className='live-wrapper'>
                                        <img src={imageLoaded[index] ? type.banner_image : logo}
                                        onLoad={() => handleImageLoad(index)}
                                        onError={addDefaultImg}
                                        height="600vh" className="d-block w-100 mscreen" alt="..." />
                                    </div>
                                </Link>
                            )
                        ) : type.banner_backlink ? (
                            <a href={type.banner_backlink} target="_blank">
                               <img src={type.full_width} 
                                    onError={addDefaultImg}
                                    height="600vh"
                                    className="d-block w-100  mscreen" alt={type.alt_text || "Slide image"} />
                            </a>
                        ): (
                            type.type_id !== 0 && type.video_type && type.video_type !== 5  ? 
                                
                            <Link to={`/${istype}/${slugify(type.name)}/${createEncodedData(type.id,type.type_id, type.video_type, type.upcoming_type)}`}className="image-gradient">
                            
                                <img src={imageLoaded[index] ? type.banner_image : logo} 
                                    onLoad={() => handleImageLoad(index)}
                                    onError={addDefaultImg}
                                    height="600vh" className="d-block w-100 mscreen" alt={type.alt_text || "Slide image"} 
                                    />
                            </Link> :
                            <div className="image-gradient">
                                <img src={imageLoaded[index] ? type.banner_image : logo}
                                onLoad={() => handleImageLoad(index)}
                                onError={addDefaultImg}
                                height="600vh" className="d-block w-100 mscreen image-gradient" alt={type.alt_text || "Slide image"} />
                            </div>
                        )}
                    </div>
                ))}
            </Slider>
        </div>
    );
}

const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{

                display: 'block',
                // background: 'rgba(0,0,0,0.5)', 
                borderRadius: '50%',
                right: '30px',
                zIndex: 1
            }}
            onClick={onClick}
        >
            <i className="fas fa-arrow-right" ></i>
        </div>
    );
}

const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{

                display: 'block',
                // background: 'rgba(0,0,0,0.5)', 
                borderRadius: '50%',
                left: '30px',
                zIndex: 1
            }}
            onClick={onClick}
        >
            <i className="fas fa-arrow-left"></i>
        </div>
    );
}

export default Slideshow;